import dJSON from 'dirty-json';

const moduleSelector = '.banner-grid';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);
      const grid = query.querySelector('.banner-grid__grid');

      data.forEach((item) => {
        const sizeMod = item.size === 'large' ? 'banner-grid__item--large' : 'banner-grid__item--small';
        const tag = item.button_link ? 'a' : 'div';
        const href = item.button_link ? ` href="${item.button_link}"` : '';

        grid.insertAdjacentHTML('beforeend', /* html */ `
          <${tag} class="banner-grid__item ${sizeMod}"${href}>
            ${item.background ? `<div class="banner-grid__media">
              <img class="banner-grid__image" src="${item.background}" alt="${item.title || ''}">
            </div>` : ''}
            <div class="banner-grid__content">
              ${item.kicker ? `<p class="banner-grid__kicker">${item.kicker}</p>` : ''}
              ${item.title ? `<h3 class="banner-grid__title">${item.title}</h3>` : ''}
              ${item.text ? `<p class="banner-grid__text">${item.text}</p>` : ''}
              ${item.button_link ? '<span class="banner-grid__button btn-custom primary">Find Out More</span>' : ''}
            </div>
          </${tag}>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
